"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnglishIcon = EnglishIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EnglishIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    height: "600",
    viewBox: "0 0 60 30",
    width: "1200"
  }, props), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,0 v30 h60 v-30 z"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,0 v30 h60 v-30 z",
    fill: "#012169"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    stroke: "#fff",
    strokeWidth: "6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipPath: "url(#t)",
    d: "M0,0 L60,30 M60,0 L0,30",
    stroke: "#C8102E",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#fff",
    strokeWidth: "10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#C8102E",
    strokeWidth: "6"
  })));
}